export default {
  // serverUrl: "https://ed11384a048d.ngrok.io",

  // serverUrl: process.env.API_SERVER_URL || "https://api.usat.uz",


  // serverUrl: "https://api.admission-usat.uicgroup.tech",

  serverUrl: "https://api.usat.uz",
  // serverUrl: "http://localhost:8081",

  // serverUrl: "http://38.226.16.106:8081",

  // serverUrl: "https://api.usat.uz",

  // serverUrl: "http://192.168.1.106:8081",
  apiVersion: "/api/v1/",
};